import { Component, OnInit } from '@angular/core';
import {AbstractControl, FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ApiService} from '../services/api.service';
import {AppComponent} from '../app.component';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { SortListService } from '../services/sort-list.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationPopoverComponent } from '../confirmation-popover/confirmation-popover.component';
import { CapturePhotoPopoverComponent } from '../capture-photo-popover/capture-photo-popover.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-shayan-aarti-booking',
  templateUrl: './shayan-aarti-booking.component.html',
  styleUrls: ['./shayan-aarti-booking.component.scss']
})
export class ShayanAartiBookingComponent implements OnInit {
  public env: any = environment;
  
  
    form: FormGroup;
    allDarshanTypes = [];
    allStates = [];
    allCities = [];
    allReferences = [];
    minDate = moment(new Date()).format('YYYY-MM-DD');
    maxDate = ''
    timeDisable = false;
    formMode = 'Add';
    visitors_basic_details: any;
    dateErrorMsg = '';
    visitor_type = [];
    id_proof_type_list = []
    allDepartments = [];
    show_reference_limit_msg = '';
    user_roles:any;
    selecedType = "bhasma_arti";
    addImageUrl = [];
    image_required = false;
    selectedElement:any;
    garbhGrahSlot = '';
    selectedDarshanType:any;
    currentRoute: string = '';
    darshanTypeId: number = 20; // Default to Shayan Aarti
    darshanTypeSlug: string = 'shayan_aarti'; // Default to Shayan Aarti
    pageHeading: string = 'Shayan Aarti Booking'; // Default heading
    allAartiHalls = [];
    allHallRows = [];                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 
  
    myFilter = (d): boolean => {
      const time = d.get('hour');
      if(time >= 6 && time <= 22){
        this.timeDisable = false;
        return true;
      } else {
        this.timeDisable = true;
        return false;
      }
    }
    apiLoadInterval = null;
  
    constructor(
      private _formBuilder: FormBuilder,
      private apiService : ApiService,
      private appComponent: AppComponent,
      private router: Router,
      private activatedRoute: ActivatedRoute,
      private sortListService: SortListService,
      private modalService: NgbModal,
  
      ) {
      }
  
    ngOnInit() {
      this.detectCurrentRoute();
      this.getAllDarshanTypes();
      this.getIdProofTypesList();
      this.getAartiHalls();
     
        this.createForm();
    }

    detectCurrentRoute() {
      this.currentRoute = this.router.url;
      if (this.currentRoute.includes('sandhya-aarti-booking')) {
        this.darshanTypeId = 21;
        this.darshanTypeSlug = 'sandhya_aarti';
        this.pageHeading = 'Sandhya Aarti Booking';
      } else {
        this.darshanTypeId = 20;
        this.darshanTypeSlug = 'shayan_aarti';
        this.pageHeading = 'Shayan Aarti Booking';
      }
    }
  
  
  
  
    checkAartiQuota() {
      const noOfPersons = this.form.value.no_of_persons;
      const payload = {
        darshan_type_slug: this.darshanTypeSlug,
        date_of_visit: moment(new Date()).format('YYYY-MM-DD'),
        no_of_persons: noOfPersons
      };
      
      this.apiService.postDataToServer('/check_aarti_quota', payload).subscribe(
        (res: any) => {
          if (res.data && res.data.available === false) {
            this.appComponent.showMessageAlert(res.message , 'error');
            this.form.disable();
          } else {
            this.form.enable();
          }
        },
        err => {
          console.error('Error checking aarti quota:', err);
          this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
        }
      );
    }

    createForm() {
      this.form = this._formBuilder.group({
        first_name: ['', [Validators.required,this.removeSpaces]],
        last_name: ['', [Validators.required,this.removeSpaces]],
        mobile_no: ['', [Validators.required, Validators.pattern('[5-9]\\d{9}')]],
        // email: [data ? data.email : '', [Validators.required, Validators.email]],
        date_of_visit: [ this.minDate, [Validators.required]],
        darshan_type_id: [ '', [Validators.required]],
        aarti_hall_id: [ '', [Validators.required]],
        aarti_hall_row_id: [ '', [Validators.required]],
        department_id: [ ''],
        no_of_persons: [ '1', [Validators.required]],
        id: [''],
        visitors_basic_details: this._formBuilder.array([this.getPersonRow()])
      });

      this.checkAartiQuota();
     
    }
  
   
  
    getPersonRow() {
      return this._formBuilder.group({
        name: ['', [Validators.required]],
        // visitor_type_ids: [''],
        age: ['', [Validators.required,Validators.min(0),Validators.max(100)]],
        gender: ['', Validators.required],
        id_proof_type_id : ['', Validators.required],
        id_proof_number  : ['', [Validators.required,this.removeSpaces]],
        image_url: ['']
      });
    }
    removeSpaces(control: AbstractControl) {
      if (control && control.value && !control.value.replace(/\s/g, '').length) {
        control.setValue('');
      }
      return null;
    }
  
    
    onChangeName() {
      const controlArray = <FormArray> this.form.get('visitors_basic_details');
      if(controlArray.controls && controlArray.controls.length) {
        controlArray.controls[0].get('name').setValue(`${this.form.value.first_name} ${this.form.value.last_name}`);
      }
    }
  
    onIdProofTypeChange(index) {
      const controlArray = <FormArray> this.form.get('visitors_basic_details');
      if(controlArray.controls && controlArray.controls.length) {
        controlArray.controls[index].get('id_proof_number').setValue('');
      }
    }
  
    getAllDarshanTypes() {
      this.apiService.getDataFromServer('/darshan_types').subscribe(
        res => {
          this.sortListService.sortList(res['data'],'name').then(res => {
            this.allDarshanTypes = res;
            if(this.allDarshanTypes.length >= 1 ){
              this.form.controls['darshan_type_id'].setValue(this.darshanTypeId);
            }
          });
          // this.allDarshanTypes = res['data'];
          
        },
        err => {
          console.log(err);
          
        }
      );
    }
  
    getIdProofTypesList() {
      this.apiService.getDataFromServer('/id_proof_types').subscribe(
        res => {
          this.sortListService.sortList(res['data'],'name').then(res => {
            this.id_proof_type_list = res;
          });
        },
        err => {
          console.log(err);
        }
      );
    }

    getAartiHalls() {
      this.apiService.getDataFromServer(`/aarti_halls_for_admin?darshan_type_id=${this.darshanTypeId}`).subscribe(
        res => {
          this.allAartiHalls = res['data'];
        },
        err => {
          console.log(err);
        }
      );
    }

    onHallChange() {
      const selectedHallId = this.form.value.aarti_hall_id;
      const selectedHall = this.allAartiHalls.find(hall => hall.id == selectedHallId);
      if (selectedHall) {
        this.allHallRows = selectedHall.rows;
        // Reset row selection when hall changes
        this.form.controls['aarti_hall_row_id'].setValue('');
      } else {
        this.allHallRows = [];
      }
    }
  
    onClickCapturePhoto(index, data) {
      console.log(this.form)
      const modalRef = this.modalService.open(CapturePhotoPopoverComponent,
        {
          centered: false, size: 'md', windowClass: 'my-class', scrollable: false,
          backdrop: 'static', keyboard: false,
        });
      const capturePhotoPopoverComponent: CapturePhotoPopoverComponent = modalRef.componentInstance;
      capturePhotoPopoverComponent.data = data;
  
      modalRef.result.then((result) => {
        if (result) {
          this.appComponent.showLoader();
          this.apiService.getBlobFileFromServer(result).subscribe(res => {
            let blob:any = new Blob([res], { type: res.type.toString() });
            const controlArray = <FormArray> this.form.get('visitors_basic_details');
            let file_name = controlArray.controls[index].get('name').value;
            const imageFile = new File([blob], `${file_name}-image`, { type: 'image/png' });
            controlArray.controls[index].get('image_url').setValue(imageFile);
            const isExist = this.addImageUrl.find((img:any) => img.index == index);
  
            if(isExist) {
              isExist.image_url = result;
              isExist.addStatus = true;
            } else {
              this.addImageUrl.push({index:index, image_url: result, addStatus: true});
            }
            this.appComponent.hideLoader();
          });
        }
      });
    }


    onFileChange(event:any, index:any) {
      if (event.target.files && event.target.files.length) {
        const controlArray = <FormArray> this.form.get('visitors_basic_details');
        controlArray.controls[index].get('image_url').setValue(event.target.files[0]);
        const isExist = this.addImageUrl.find((img:any) => img.index == index);
  
        const reader = new FileReader();
        reader.onload = (e: any) => {
          if(isExist) {
            isExist.image_url = e.target.result;
            isExist.addStatus = true;
          } else {
            this.addImageUrl.push({index:index, image_url: e.target.result, addStatus: true});
          }
        };
        reader.readAsDataURL(event.target.files[0]);
      }
      console.log(this.form)
    }
  
    findImageUrl(index) {
      const imageData = this.addImageUrl.find(res => res.index == index);
      return imageData && imageData.image_url ? imageData.image_url : '';
    }
  
    async saveImageData(): Promise<void>  {
      this.appComponent.showLoader();
      let data:any = null;
      let count = 0;
      let receivedCount = 0;
      if(this.image_required) {
        const visitors_basic_details = this.form.value.visitors_basic_details;
        visitors_basic_details.map(async (res, index) => {
          // await this.actulePlaceOrder(report, index, data.length);
          const isExist = this.addImageUrl.find(img => img.index == index);
          if(isExist && isExist.addStatus) {
            count = count + 1;
            data = await this.addImage(res,index);
            if(data) {
              receivedCount = receivedCount + 1
            }
            if(data && receivedCount == count) {
              this.saveData();
            }
          }
  
          const isExist1 = this.addImageUrl.find(img => img.addStatus == true);
          if(!isExist1) {
            this.saveData();
          }
  
        });
        // visitors_basic_details.map((res, index) => {
        //  const isExist = this.addImageUrl.find(img => img.index == index);
        //  if(isExist && isExist.addStatus) {
        //    this.addImage(res,index);
        //  }
        // });
        // setTimeout(() => {
        //   this.saveData();
        // }, 4000);
      } else {
        this.saveData();
      }
  
    }
  
    addImage(res,index): Promise<void>  {
      return new Promise((resolve) => {
        var formData = new FormData();
        formData.append('file', res.image_url);
        this.apiService.postDataToServer('/add_image', formData).subscribe(
          (res:any) => {
            const controlArray = <FormArray> this.form.get('visitors_basic_details');
            controlArray.controls[index].get('image_url').setValue(res.data);
            resolve(res);
          },err => {
            this.appComponent.hideLoader();
            this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
            console.log(err);
          });
      });
  
    }
  
  
  
    saveData() {
      const formObj = this.form.getRawValue();
  
      formObj.date_of_visit = moment(formObj.date_of_visit).format('YYYY/MM/DD');
  
      if(this.formMode == 'Add') {
        
        this.appComponent.showLoader();
        this.apiService.postDataToServer('/visitors', formObj).subscribe(
          (res:any) => {
            this.router.navigate(['/registration-success', res['data']['id']]);
            this.appComponent.showMessageAlert(res['message'], 'success');
            this.createForm();
            if(res.data && res.data.payment_status == 'Paid') {
              this.generateEnterPass(res.data.id);
            }
            setTimeout(() => {
              this.appComponent.hideLoader();
            },200);
          },
          err => {
            this.appComponent.hideLoader();
            if(err.error.status_code == 400){
            } else {
            this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
            }
            console.log(err);
          }
        );
      } 
    }
  
  
   generateEnterPass(id) {
    this.apiService.getDataFromServer('/generate_entry_pass/' + id).subscribe(
      res => {
        window.open(res['data'][0]);
      },
      err => {
        console.log(err);
      }
    );
   }
   
  
    onPersonCountChange(type?){
      this.addImageUrl = [];
      let visitors_basic_details : any  = <FormArray>this.form.controls['visitors_basic_details'];
  
      visitors_basic_details.clear();
  
      if(this.visitors_basic_details) {
  
        this.visitors_basic_details.map((res, index) => {
          if(this.form.controls['no_of_persons'].value >= (index + 1) ) {
            visitors_basic_details.push(this._formBuilder.group({
              name: [res.name, [Validators.required]],
              // visitor_type_ids: [res.visitor_type],
              age: [res.age, [Validators.required, Validators.min(0),Validators.max(100)]],
              gender: [res.gender, Validators.required],
              id_proof_type_id : [res.id_proof_type_id ? res.id_proof_type_id : '' , Validators.required],
              id_proof_number  : [res.id_proof_number ? res.id_proof_number : '', Validators.required],
              id: [res.id],
              image_url: [res.image_url, this.image_required ? Validators.required : '']
            }));
            if(type) {
              if(res.image_url) {
                this.addImageUrl.push({index:index, image_url: `${res.image_url}`, addStatus: false});
              }
            }
          }
  
        })
  
        if(this.form.controls['no_of_persons'].value != this.visitors_basic_details.length) {
          for (let i=0; i< this.form.controls['no_of_persons'].value - this.visitors_basic_details.length; i++) {
            visitors_basic_details.push(this._formBuilder.group({
              name: ['', [Validators.required]],
              // visitor_type_ids: [''],
              age: ['', [Validators.required, Validators.min(0),Validators.max(100)]],
              gender: ['', Validators.required],
              id_proof_type_id : ['', Validators.required],
              id_proof_number  : ['', Validators.required],
              image_url: ['', this.image_required ? Validators.required : '']
  
            }));
          }
        }
  
      } else {
        visitors_basic_details.push(this._formBuilder.group({
          name: [this.form.controls['first_name'].value + ' ' + this.form.controls['last_name'].value, [Validators.required]],
          // visitor_type_ids: [''],
          age: ['', [Validators.required,Validators.min(0),Validators.max(100)]],
          gender: ['', Validators.required],
          id_proof_type_id : ['', Validators.required],
          id_proof_number  : ['', Validators.required],
          image_url: ['', this.image_required ? Validators.required : '']
        }));
  
        let darshan_type_id = this.form.controls['darshan_type_id'].value;
          for (let i=0; i< this.form.controls['no_of_persons'].value -1 ; i++) {
            visitors_basic_details.push(this._formBuilder.group({
              name: ['', [Validators.required]],
              // visitor_type_ids: [''],
              age: ['', [Validators.required, Validators.min(0),Validators.max(100)]],
              gender: ['', Validators.required],
              id_proof_type_id : ['', darshan_type_id != 3 ? [Validators.required] : ''],
              id_proof_number  : ['', darshan_type_id != 3 ? [Validators.required] : ''],
              image_url: ['',  this.image_required && darshan_type_id != 3 ? [Validators.required] : '']
            }));
  
          }
      }
     
      // Check quota when number of persons changes
      if (!type || type !== 'onLoad') {
        this.checkAartiQuota();
      }
    }


    onChangePeopleProofNumber(i) {
      const controlArray = <FormArray> this.form.get('visitors_basic_details');
      if (controlArray.controls[i].get('id_proof_number') && controlArray.controls[i].get('id_proof_number').value && !controlArray.controls[i].get('id_proof_number').value.replace(/\s/g, '').length) {
        controlArray.controls[i].get('id_proof_number').setValue('');
      }
    }
  
    onChangePeopleName(i) {
      const controlArray = <FormArray> this.form.get('visitors_basic_details');
      if (controlArray.controls[i].get('name') && controlArray.controls[i].get('name').value && !controlArray.controls[i].get('name').value.replace(/\s/g, '').length) {
        controlArray.controls[i].get('name').setValue('');
      }
    }
  
    public remove(i: number) {
      this.form.get('no_of_persons').setValue(this.form.value.no_of_persons - 1);
      const contrls = <FormArray>this.form.controls['visitors_basic_details'];
      contrls.removeAt(i);
    }
  
    keyPressNumbers(event) {
      var charCode = (event.which) ? event.which : event.keyCode;
      // Only Numbers 0-9
      if ((charCode < 48 || charCode > 57)) {
        event.preventDefault();
        return false;
      } else {
        return true;
      }
    }
  
    
  }
  